import React from 'react'
import { FormattedMessage } from 'react-intl'
import { View } from 'react-native'

import { useTheme } from 'styled-components/native'

import { UtilityButton } from './UtilityButton'
import { BodyText } from '../../atoms/bodyText/BodyText'
import { DraftPageIcon } from '../../atoms/icons/DraftPageIcon'
import { PencilSparkleIcon } from '../../atoms/icons/PencilSparkleIcon'
import { RulerAndPencilIconFilled } from '../../atoms/icons/RulerAndPencilIconFilled'
import { BodyTextSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { tID } from '../../utils/utils'

export type MessengerUtilitiesProps = {
  onSmartSuggestionPress?: () => void
  onTemplatesPress?: () => void
  onDraftsPressed?: () => void
  openUtilityItem: MessengerUtilityItems | null
  setOpenUtilityItem: (item: MessengerUtilityItems | null) => void
  smartSuggestionCounter?: number
}

export enum MessengerUtilityItems {
  SMART_SUGGESTIONS = 'smartSuggestions',
  TEMPLATES = 'templates',
  DRAFTS = 'drafts',
}

const MessengerUtilityItemTitles = {
  [MessengerUtilityItems.SMART_SUGGESTIONS]: (
    <FormattedMessage
      defaultMessage='Smart suggestions'
      description='Button that show smart suggestions section to user'
    />
  ),
  [MessengerUtilityItems.TEMPLATES]: (
    <FormattedMessage defaultMessage='Templates' description='Button that show templates section to user' />
  ),
  [MessengerUtilityItems.DRAFTS]: (
    <FormattedMessage defaultMessage='Drafts' description='Button that show drafts section to user' />
  ),
}

export const MessengerUtilities = ({
  onSmartSuggestionPress,
  onTemplatesPress,
  onDraftsPressed,
  openUtilityItem,
  setOpenUtilityItem,
  smartSuggestionCounter,
}: MessengerUtilitiesProps) => {
  const { colors } = useTheme() as ThemeType
  return (
    <View testID={tID('MessengerUtilities')}>
      {onSmartSuggestionPress && (
        <UtilityButton
          testID={tID('MessengerUtilities-smartSuggestions')}
          active={openUtilityItem === MessengerUtilityItems.SMART_SUGGESTIONS}
          onPress={() => {
            setOpenUtilityItem(MessengerUtilityItems.SMART_SUGGESTIONS)
            onSmartSuggestionPress()
          }}
          leftIcon={<PencilSparkleIcon size={20} fillColor={colors.iconDefault} />}
          text={
            <BodyText
              text={MessengerUtilityItemTitles[MessengerUtilityItems.SMART_SUGGESTIONS]}
              color={colors.textPrimary}
              size={BodyTextSize.SMALL}
            />
          }
          counter={smartSuggestionCounter}
        />
      )}
      {onTemplatesPress && (
        <UtilityButton
          testID={tID('MessengerUtilities-templates')}
          active={openUtilityItem === MessengerUtilityItems.TEMPLATES}
          onPress={() => {
            setOpenUtilityItem(MessengerUtilityItems.TEMPLATES)
            onTemplatesPress()
          }}
          leftIcon={<RulerAndPencilIconFilled size={20} fillColor={colors.iconDefault} />}
          text={
            <BodyText
              text={MessengerUtilityItemTitles[MessengerUtilityItems.TEMPLATES]}
              color={colors.textPrimary}
              size={BodyTextSize.SMALL}
            />
          }
        />
      )}
      {onDraftsPressed && (
        <UtilityButton
          testID={tID('MessengerUtilities-drafts')}
          active={openUtilityItem === MessengerUtilityItems.DRAFTS}
          onPress={() => {
            setOpenUtilityItem(MessengerUtilityItems.DRAFTS)
            onDraftsPressed()
          }}
          leftIcon={<DraftPageIcon size={24} color={colors.iconDefault} />}
          text={
            <BodyText
              text={MessengerUtilityItemTitles[MessengerUtilityItems.DRAFTS]}
              color={colors.textPrimary}
              size={BodyTextSize.SMALL}
            />
          }
        />
      )}
    </View>
  )
}
